import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Text } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { useDashMessages } from 'intl/intl.hooks'
import { type BannerDetailExperimentValues } from 'domains/banners/types/banner.types'

const sectionContainer = css({
  display: 'flex',
  '& > div': {
    flex: '1 0 33%',
  },
})

export const BannerDetailsExperiment: FunctionComponent<BannerDetailExperimentValues> = ({
  experiment,
}) => {
  const messages = useDashMessages({
    emptyValue: 'bannersDomain.field.empty.value',
    nameLabel: 'bannersDomain.details.experiment.name',
    variantLabel: 'bannersDomain.details.experiment.variant',
    accessMethodLabel: 'bannersDomain.details.experiment.access-method',
  })

  const { name, variant, accessMethod } = experiment

  return (
    <MerchandisingFormSection titleId="bannersDomain.details.experiment.title">
      <div css={sectionContainer}>
        <div>
          <Text weight="semibold">{messages.nameLabel}</Text>
          <Text size="medium">{name || messages.emptyValue}</Text>
        </div>
        <div>
          <Text weight="semibold">{messages.variantLabel}</Text>
          <Text size="medium">{variant || messages.emptyValue}</Text>
        </div>
        <div>
          <Text weight="semibold">{messages.accessMethodLabel}</Text>
          <Text size="medium">{accessMethod || messages.emptyValue}</Text>
        </div>
      </div>
    </MerchandisingFormSection>
  )
}

export enum PlacementExperimentMethodEnum {
  /** Not specified */
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  /** Whether variant assignment should happen */
  Assign = 'ASSIGN',
  /** Whether a simple variant lookup should occur */
  Lookup = 'LOOKUP',
}
